import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { STextField } from './styled';
import { Box as MuiBox } from '@mui/material';
import { FormControl, FormAutocomplete } from 'components/ui';
import { getFormattedCountriesArr } from 'lib/utils/getCountriesList';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import FormTimezoneSelector from 'components/ui/FormTimeZoneSelector';

export default function Address({ isPreferredTimeZoneRequired = true }) {
  const { t } = useTranslation();

  const countriesArr = getFormattedCountriesArr();

  return (
    <Accordion
      startAdornment={<LocationOnOutlinedIcon />}
      title={t('Address') + (isPreferredTimeZoneRequired ? ' *' : '')}
    >
      <FormControl label={t('Address line')}>
        <STextField name="address.address" placeholder={t('Address line')} />
      </FormControl>
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('City')}>
          <STextField name="address.city" placeholder={t('City')} />
        </FormControl>
        <FormControl label={t('Postal code')}>
          <STextField name="address.zipcode" placeholder={t('Postal code')} />
        </FormControl>
      </MuiBox>
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('State')}>
          <STextField name="address.state" placeholder={t('State')} />
        </FormControl>
        <FormControl label={t('Country')}>
          <FormAutocomplete
            name="address.country"
            data-id="country-input"
            options={countriesArr}
            getOptionValue={(option) => option?.name?.name || ''}
            getOptionLabel={(option) => option?.name?.name || ''}
            placeholder={t('Country')}
          />
        </FormControl>
      </MuiBox>
      <FormControl
        label={t('Time zone') + (isPreferredTimeZoneRequired ? ' *' : '')}
      >
        <FormTimezoneSelector name="preferredTimeZone" />
      </FormControl>
    </Accordion>
  );
}
